// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"dc817d17","232":"5797bf56","465":"4bf35701","473":"81a71b95","538":"58673feb","659":"686f6d3b","828":"3b8e9587","833":"450c4c87","979":"9bf035dc"}[chunkId] + ".chunk.js";
};